import React from "react";
import { FACEBOOK_URL } from "../../../helpers/socialMediaUrls";
import { StyledFacebookIcon } from './FacebookIcon.styled';

export const FacebookIcon = () => {
    return <a href={FACEBOOK_URL} target='_blank'><StyledFacebookIcon/></a>
}